import PropTypes from "prop-types"
import { Component } from "react"
import { formatLongDate } from "helpers/formatters/dates"
import { DATE } from "helpers/shapes"
import Factor from "./components/factor"
import "./style.scss"
import { ArrowDropDown } from "@mui/icons-material"

const TOP_FACTOR = PropTypes.shape({
  id: PropTypes.string.isRequired,
  pnl: PropTypes.number.isRequired,
  beta: PropTypes.number,
  label: PropTypes.string,
  performance: PropTypes.number,
}).isRequired

class PerformanceTopFactors extends Component {
  static propTypes = {
    topFactors: PropTypes.shape({
      positive: PropTypes.arrayOf(TOP_FACTOR).isRequired,
      negative: PropTypes.arrayOf(TOP_FACTOR).isRequired,
    }).isRequired,
    max: PropTypes.number.isRequired,
    valueFormatter: PropTypes.func.isRequired,
    betaLabel: PropTypes.string,
    startDate: DATE.isRequired,
    endDate: DATE.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    category: PropTypes.string.isRequired,
    setCategory: PropTypes.func.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
    hasAggregatedFactors: PropTypes.bool.isRequired,
  }

  setCategory = event => {
    const { setCategory } = this.props
    setCategory(event.target.value)
  }

  render() {
    const { max, topFactors: { positive, negative }, betaLabel, valueFormatter, openFactorProfile, startDate, endDate, categories, category, hasAggregatedFactors } = this.props
    const commonProps = { max, openFactorProfile, displayBeta: !!betaLabel, displayReturn: !hasAggregatedFactors, valueFormatter }

    return <div className="modules_performance-top-factors">
      <h5>
        <span className="inline-select">
          <select value={category} onChange={this.setCategory}>
            <option value="">Top Factor Contributors</option>
            {categories.map(({ id, label }) => <option key={id} value={id}>{`Top ${label} Factors Contributors`}</option>)}
          </select>
          <ArrowDropDown />
        </span>
        <span className="dates">{`${formatLongDate(startDate)} - ${formatLongDate(endDate)}`}</span>
      </h5>

      <div className="headers">
        {betaLabel && <div className="beta">{betaLabel}</div>}
        {!hasAggregatedFactors && <div className="return">Factor Return</div>}
      </div>
      {positive.map(factor => <Factor key={factor.id} {...factor} {...commonProps} />)}
      {negative.map(factor => <Factor key={factor.id} {...factor} {...commonProps} />)}
    </div>
  }
}

export default PerformanceTopFactors
